const tutorial = {
  title: "Willkommen bei XLplanner!",
  description: "Wir führen Sie gleich durch ein Tutorial, mit dem Sie unsere Anwendung besser kennenlernen und viele wertvolle Tipps erhalten.",
  go: "Los geht's!",
  end: "Ende!",
  
  company: {
    title: "Unternehmen",
    subtitle: "Wählen Sie den Tab Unternehmen im oberen Menü",
    description: "In diesem Bereich können Sie die wichtigsten Aktionen in Bezug auf Ihr Unternehmen durchführen.",
    menu: {
      company: "Unternehmen",
      employees: "Mitarbeiter",
      drivers: "Fahrer",
      documents: "Dokumente",
      myCars: "Meine Fahrzeuge",
      insurance: "Versicherungen"
    },
    details: "Auf der linken Seite sehen Sie ein Menü, mit dem Sie Ihr Unternehmen verwalten können. Hier können Sie unter anderem:",
    features: {
      personalize: "Das Aussehen Ihres Profils personalisieren, indem Sie Unternehmensfotos hinzufügen",
      addEmployees: "Mitarbeiter hinzufügen, die Ihnen bei der Verwaltung von Aufträgen helfen",
      manageDrivers: "Fahrer verwalten, die die Transporte ausführen",
      uploadDocuments: "Dokumente hochladen und verifizieren, die dir helfen, dein Unternehmen besser zu präsentieren",
      addCars: "Unternehmenseigene Fahrzeuge hinzufügen und die Gültigkeit ihrer Versicherungen kontrollieren"
    }
  },
  
  wallet: {
    title: "Wallet",
    description: "Hier können Sie den Status Ihres Abonnements einsehen.",
    menu: {
      subscription: "Abonnement",
      invoices: "Rechnungen"
    },
    details: "Im Menü finden Sie folgende Optionen: ",
    details1:"Prüfen Sie die Gültigkeit Ihres Abonnements und verlängern Sie es",
    details2:"Sehen Sie sich den Verlauf Ihrer Rechnungen an und laden Sie die benötigten Dokumente herunter"
  },
  
  pilot: {
    exchange: {
      title: "Börse",
      subtitle: "Gehen Sie zum Tab Börse, indem Sie ihn im oberen Menü auswählen",
      description: "Die Börse ist der Bereich, in dem Sie nach Aufträgen von Spediteuren suchen und anschließend Angebote für ausgewählte Aufträge abgeben können. Sie haben auch die Möglichkeit, Ihr Unternehmen selbst in der App zu präsentieren, damit Spediteure Ihr Profil leicht finden und direkt über den Chat mit Ihnen in Kontakt treten können.",
      menu: {
        exchange: "Börse",
        pilotOffers: "Pilotenangebote",
        transports: "Transporte",
        archive: "Auftragsarchiv"
      },
      details: "Nach dem Aufklappen des Menüs erhalten Sie die Möglichkeit:",
      features: {
        browseOrders: "Aufträge an der Börse durchzusehen",
        submitOffers: "Angebote für gewünschte Aufträge abzugeben",
        checkStatus: "Den aktuellen Status der Aufträge, auf die Sie bieten, zu prüfen",
        addAnnouncement: "Ein Angebot Ihres Unternehmens in der Liste der Piloten-Anzeigen hinzuzufügen",
        browseArchive: "Archivierte Aufträge durchzusehen"
      }
    }
  },
  
  driver: {
    exchange: {
      title: "Börse",
      subtitle: "Die Börse ist ein Ort, an dem du Transportaufträge einstellen und anschließend die Angebote der Piloten für deine Aufträge einsehen kannst. Du hast außerdem die Möglichkeit, selbst die Anzeigen der Piloten zu durchsuchen und sie direkt im Chat zu kontaktieren.",
      menu: {
        exchange: "Börse",
        myOffers: "Meine Angebote",
        transports: "Transporte",
        archive: "Auftragsarchiv"
      },
      details: "Nach dem Aufklappen des Menüs haben Sie die Möglichkeit:",
      features: {
        browseOrders: "Aufträge auf der Börse einstellen und durchsuchen",
        submitOffers: "Angebote für gewünschte Aufträge ansehen oder abgeben",
        checkStatus: "Den aktuellen Status der Aufträge prüfen, auf die du dich beworben hast",
        addAnnouncement: "Das Angebot deiner Firma zur Liste der Pilotanzeigen hinzufügen",
        browseArchive: "Archivierte Aufträge durchsuchen"
      }
    }
  },
  
  closeDialog: "Symbol zum Schließen des Dialogs",
  page: {
    oneOfSix: "1/6",
    twoOfSix: "2/6",
    threeOfSix: "3/6",
    fourOfSix: "4/6",
    fiveOfSix: "5/6",
    sixOfSix: "6/6"
  }
};

export default tutorial;